import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
//@ts-ignore
import { ReactNode, useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import { postApiFormData } from "../../helpers/AxiosInstance";
import { IGetStartedFrom } from "../../types/interface";
import { validateOrganizationSetup } from "../../validation/GetStarted";
import DateField from "../Reusable/DateField";
import ImageField from "../Reusable/ImageField";
import TextField from "../Reusable/TextField";
import Button from "../Reusable/Button";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import { toast } from "react-toastify";
interface Props {
  setModalPopup?: React.Dispatch<React.SetStateAction<boolean>>;
  data?: any;
}

function getNepaliFiscalYearStart(): string {
  const today = new Date();
  const year = today.getFullYear();
  const start = new Date(`${year}-07-17`);
  return today >= start ? `${year}-07-17` : `${year - 1}-07-17`;
}

function getNepaliFiscalYearEnd(): string {
  const startDate = new Date(getNepaliFiscalYearStart());
  const endDate = new Date(startDate);
  endDate.setFullYear(endDate.getFullYear() + 1);
  endDate.setDate(endDate.getDate() - 1);
  return endDate.toISOString().split("T")[0];
}

export default function SetupForm({ setModalPopup, data }: Props) {
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<IGetStartedFrom>({
    resolver: yupResolver(validateOrganizationSetup),
    defaultValues: async () => {
      const fiscalYearStart =
        data?.fiscal_year?.start_date || getNepaliFiscalYearStart();
      const fiscalYearEnd =
        data?.fiscal_year?.end_date || getNepaliFiscalYearEnd();
      return {
        ...data,
        fiscal_year_start: fiscalYearStart,
        fiscal_year_end: fiscalYearEnd,
      };
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleOrganizationCreate = async (data: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.COMPANY_PROFILE;
    const formData = new FormData();
    formData.append("name", data?.name);
    formData.append("address", data?.address);
    formData.append("phone", data?.phone);
    formData.append("vat_no", data?.vat_no);
    data?.email ? formData.append("email", data?.email) : null;
    data?.website ? formData.append("website", data?.website) : null;
    // formData.append("bank_name", data?.bank_name);
    const formattedFiscalYearStart = data?.fiscal_year_start
      ? new Date(data.fiscal_year_start).toISOString().split("T")[0]
      : null;

    const formattedFiscalYearEnd = data?.fiscal_year_end
      ? new Date(data.fiscal_year_end).toISOString().split("T")[0]
      : null;

    if (formattedFiscalYearStart) {
      formData.append("fiscal_year_start", formattedFiscalYearStart);
    }

    if (formattedFiscalYearEnd) {
      formData.append("fiscal_year_end", formattedFiscalYearEnd);
    }
    if (data?.logo && data?.logo instanceof File) {
      formData.append("logo", data.logo);
    }
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 200 || res?.status === 201) {
        toast.success("Saved Successfully");
        setModalPopup(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleOrganizationCreate(data, setError)
      )}
      autoComplete="off"
    >
      <FormSection title="General Information">
        <div className={tw`grid grid-cols-2 gap-x-4 `}>
          <div>
            <TextField
              required
              control={control}
              placeholder="Company Name"
              name="name"
              label="Company Name"
              autoFocus={true}
            />
            <TextField
              required
              control={control}
              placeholder="Address"
              name="address"
              label="Address"
            />
            <div className={tw`mt-4`}>
              <PhoneNumberField
                control={control}
                label={"Phone Number"}
                name={"phone"}
                required
                errors={errors?.phone}
              />
            </div>
            <TextField
              required
              control={control}
              placeholder="Vat no."
              name="vat_no"
              label="VAT Number"
            />
          </div>
          <div className={tw``}>
            <ImageField control={control} name="logo" />
            <TextField
              control={control}
              placeholder="Email"
              name="email"
              label="Email"
            />
            <TextField
              control={control}
              placeholder="Website"
              name="website"
              label="Website"
            />
          </div>
        </div>
      </FormSection>
      <FormSection title="Region Settings" border={false}>
        <div className={tw`grid grid-cols-2 gap-x-4 `}>
          {/* <TextField
            required
            control={control}
            placeholder="Enter Bank Name"
            name="bank_name"
            label="Bank Name"
          /> */}
          <DateField
            control={control}
            placeholder="Select Start Date"
            name="fiscal_year_start"
            limitMaxDay={false}
            label="Fiscal Year Start Date"
          />
          <DateField
            control={control}
            placeholder="Select End Date"
            limitMaxDay={false}
            name="fiscal_year_end"
            label="Fiscal Year End Date"
          />
        </div>
      </FormSection>
      <div className={tw`flex items-center justify-end gap-x-4 mt-2`}>
        <div className={tw`w-24`}>
          <Button label="Submit" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
}

function FormSection({
  title,
  children,
  border = true,
}: {
  title: string;
  children: ReactNode;
  border?: boolean;
}) {
  return (
    <>
      <section>
        <h3 className={tw`text-base font-semibold leading-8 text-[#272727]`}>
          {title}
        </h3>
        {children}
      </section>
      {border && (
        <div
          style={{
            gridColumn: "1/-1",
          }}
          className={tw`py-2`}
        >
          <hr />
        </div>
      )}
    </>
  );
}
